export const ScrollBehavior: { [key: string]: ScrollBehavior } = {
    smooth: 'smooth',
    auto: 'auto'
};
